
import * as React from "react";
import { Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/contexts/ThemeContext";

export function ThemeToggle() {
  const { theme } = useTheme();
  
  return (
    <Button 
      variant="ghost" 
      size="icon" 
      className="size-8 rounded-md"
      aria-label="Light mode is enabled"
      disabled
    >
      <Sun className="h-4 w-4 text-primary" />
      <span className="sr-only">Light mode is enabled</span>
    </Button>
  );
}
